module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 148
// module chunks = 0